module.exports = __webpack_public_path__ + "static/img/首页方案3.d420b451.png";